<template>
  <v-dialog v-bind="computedProps" v-on="computedListeners" v-model="showDialog">
    <v-card min-height="80%" min-width="80%">
      <v-toolbar elevation="2" color="primary" dark dense>
        <v-spacer/>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid class="ma-0 pa-2">
          <dd-sub-header>
            <span>以下の検索条件で絞り込む</span>
            <span style="float: right;">
              <dd-transparent-button :minWidth="140" @click="isConditionHide = !isConditionHide">
              <div v-if="!isConditionHide" class="condition-expansion">検索条件を閉じる<v-icon>mdi-chevron-up</v-icon></div>
              <div v-else class="condition-expansion">検索条件を開く<v-icon>mdi-chevron-down</v-icon></div>
              </dd-transparent-button>
            </span>
          </dd-sub-header>
          <div v-if="!isConditionHide" class="px-1 pt-0 pb-2 condition-area">
            <v-row no-gutters>
              <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12" class="px-1">
                <dd-text-box
                  label="テンプレート名称"
                  v-model="conditions.xlsTemplateNm"
                  :length="50"
                  :valueType="Ctrls.InputTypes.Free"
                />
              </v-col>
            </v-row>

            <template v-if="true">
              <v-row no-gutters>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="営業所コード/名称"
                    v-model="conditions.eigyoshoCd"
                    :length="100"
                    :required="false"
                    :readonly="eigyoshoReadOnly"
                    :valueType="Ctrls.InputTypes.Free"
                    item-value="eigyoshoCd"
                    item-text="eigyoshoNm"
                    titleText="営業所マスタ検索"
                    :headerList="headersEigyoshoList"
                    :itemList="filteredEigyoshoList"
                    :abbreviatedDisplay="abbreviatedDisplayChild"
                    :itemsPerPage.sync="itemsPerPageChild"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="人員コード/名称"
                    v-model="conditions.jininCd"
                    :length="100"
                    :required="false"
                    :readonly="false"
                    :valueType="Ctrls.InputTypes.Free"
                    item-value="jininCd"
                    item-text="jininNm"
                    titleText="人員マスタ検索"
                    :headerList="headersJininList"
                    :itemList="filteredJininList"
                    :abbreviatedDisplay="abbreviatedDisplayChild"
                    :itemsPerPage.sync="innerItemsPerPageChild"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="車両番号/自動車表示名"
                    v-model="conditions.sharyoCd"
                    :length="100"
                    :required="false"
                    :readonly="false"
                    :valueType="Ctrls.InputTypes.Free"
                    item-value="sharyoNo"
                    item-text="jidoshaHyojiNm"
                    titleText="車両マスタ検索"
                    :headerList="headersSharyoList"
                    :itemList="filteredSharyoList"
                    :abbreviatedDisplay="abbreviatedDisplayChild"
                    :itemsPerPage.sync="innerItemsPerPageChild"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="取引先コード/名称"
                    v-model="conditions.torihikisakiCd"
                    ref="torihikisakiCd"
                    :length="100"
                    :required="false"
                    :readonly="false"
                    :valueType="Ctrls.InputTypes.Free"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    titleText="取引先マスタ検索"
                    :headerList="headersTorihikisakiList"
                    :itemList="filteredTorihikisakiList"
                    :abbreviatedDisplay="abbreviatedDisplayChild"
                    :itemsPerPage.sync="innerItemsPerPageChild"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="品名コード/名称"
                    v-model="conditions.hinmeiCd"
                    :length="100"
                    :required="false"
                    :readonly="false"
                    :valueType="Ctrls.InputTypes.Free"
                    item-value="hinmeiCd"
                    item-text="hinmeiNm"
                    titleText="品名マスタ検索"
                    :headerList="headersHinmeiList"
                    :itemList="filteredHinmeiList"
                    :abbreviatedDisplay="abbreviatedDisplayChild"
                    :itemsPerPage.sync="innerItemsPerPageChild"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="発地コード/名称"
                    v-model="conditions.hatsuchiCd"
                    :length="100"
                    :required="false"
                    :readonly="false"
                    :valueType="Ctrls.InputTypes.Free"
                    item-value="hacchakuchiCd"
                    item-text="hacchakuchiNm"
                    titleText="発着地マスタ検索"
                    :headerList="headersHacchakuchiList"
                    :itemList="filteredHatsuchiList"
                    :abbreviatedDisplay="abbreviatedDisplayChild"
                    :itemsPerPage.sync="innerItemsPerPageChild"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="着地コード/名称"
                    v-model="conditions.chakuchiCd"
                    :length="100"
                    :required="false"
                    :readonly="false"
                    :valueType="Ctrls.InputTypes.Free"
                    item-value="hacchakuchiCd"
                    item-text="hacchakuchiNm"
                    titleText="発着地マスタ検索"
                    :headerList="headersHacchakuchiList"
                    :itemList="filteredChakuchiList"
                    :abbreviatedDisplay="abbreviatedDisplayChild"
                    :itemsPerPage.sync="innerItemsPerPageChild"
                  />
                </v-col>
              </v-row>
            </template>

            <v-row class="mt-2" justify="center">
              <dd-custom-button
                :rounded="true"
                :minWidth="200"
                :large="true"
                @click="onSearchButtonClick">
                検索をする
              </dd-custom-button>
              <a class="condition-clear" @click="onClearButtonClick">
                条件をクリア
              </a>
            </v-row>
          </div>

          <div class="px-1 py-2" v-if="filteredRows.length > 0">
            <v-row no-gutters>
              <v-col :xs="5" :sm="5" :md="5" :lg="2" :xl="2" :cols="5" class="px-1">
                <span class="search-number">{{ filteredRows.length }}</span>件 の検索結果
              </v-col>
              <v-col :xs="7" :sm="7" :md="7" :lg="4" :xl="4" :cols="7" v-if="!abbreviatedDisplay">
                <a
                  class="condition-clear-bottom"
                  @click="onClearButtonClick">
                  条件をクリア
                </a>
              </v-col>
              <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="mt-2" v-if="!abbreviatedDisplay">
                <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
              </v-col>
              <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="px-1">
                <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
              </v-col>
            </v-row>

            <hr class="section-line mb-2">

            <v-row no-gutters justify="end">
              <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12" class="mt-auto">
                <span>項目の値を変更し、保存することができます。</span>
              </v-col>
              <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12">
                <v-row no-gutters justify="end">
                  <dd-select-items-per-page
                    ref="pagination1"
                    :itemsPerPage.sync="innerItemsPerPage"
                    :currentPage.sync="page"
                    :items="filteredRows"
                    @changeItemsPerPage="changeItemsPerPage"
                    @changePage="changePage"
                  />
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters class="d-block">
              <v-data-table
                item-key="id"
                :headers="headers"
                :items="filteredRows"
                :custom-filter="filtering"
                :search="searchText"
                :items-per-page="innerItemsPerPage"
                :page.sync="page"
                @dblclick:row="onRowDoubleClick"
                no-data-text="対象データはありません"
                fixed-header
                :hide-default-header="abbreviatedDisplay"
                hide-default-footer
                locale="ja-jp"
                dense
              >
                <template v-slot:[`item.actions`]="{item}">
                  <v-chip
                    small
                    color="primary"
                    @click="onRowSelectButtonClick(item)"
                  >
                    選択
                  </v-chip>
                </template>
                <template v-slot:[`item.delete`]="{item}">
                  <dd-icon-button-with-tooltip
                    message="行を削除します<br>※保存をするまで反映されません"
                    icon="mdi-delete"
                    @click="onRowDeleteButtonClick(item)"
                  />
                </template>
                <template v-slot:[`item.xlsTemplateNm`]="{item}">
                  <dd-edit-dialog
                    :key="editDialogKey"
                    :value.sync="item.xlsTemplateNm"
                    :valueType="Ctrls.InputTypes.Free"
                    :required="true"
                    @save="onSaveXlsTemplateNm($event, item)"
                    @close="onCloseXlsTemplateNm(item)"
                  />
                </template>
                <template v-slot:[`item.hyojiOrderDisp`]="{item}">
                  <dd-edit-dialog
                    :value.sync="item.hyojiOrderDisp"
                    :valueType="Ctrls.InputTypes.Numerical"
                    :numMax="9999"
                    :numMin="0"
                    :numIntegerDigit="4"
                    :numMinorDigit="0"
                    :required="true"
                    @save="onSaveXlsHyojiOrder($event, item)"
                  />
                </template>
              </v-data-table>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters class="px-1 py-0 mt-3">
          <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12">
            <dd-transparent-button :minWidth="120" @click="onCloseClick">
              <v-icon color="#1F2B38">mdi-close-circle</v-icon>ヘルプを閉じる
            </dd-transparent-button>
          </v-col>
          <v-spacer></v-spacer>
          <dd-custom-button
            tooltipText="変更した内容を保存します。"
            :tooltipTop="true"
            :enableToolTip="true"
            :rounded="false"
            color="#e65100"
            dark
            @click="onSaveButtonClick"
          >
            変更した内容を保存する
          </dd-custom-button>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdCodeTextBoxChild from './DdCodeTextBoxChild.vue'
import DdCustomButton from '@/components/DdCustomButton'
import DdEditDialog from '@/components/DdEditDialog'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'
import DdTransparentButton from '@/components/DdTransparentButton'

import dolly from '@/rahmen/utils/dolly'
import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'
import filter from '@/rahmen/utils/filters'
import modals from '@/ddv2.library/modals'
/**
 * @file スプレッドシート用テンプレート検索/編集用ダイアログ
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [showDialog=false] - ダイアログ表示可否
 * @vue-prop {String} titleText - ダイアログ用表示タイトル
 * @vue-prop {String} headerType - mstXlsImportMappingの対象formatCd
 * @vue-prop {String} eigyoshoReadOnly - 営業所ロックフラグ
 * @example
    <dd-xls-template-search-dialog
      :showDialog="showDialog"
      :titleText="titleText"
      :headerType="headerType"
      :eigyoshoReadOnly="eigyoshoReadOnly"
      [atmark]select="onDialogSelected"
      [atmark]close="onDialogClosed"/>
 */
export default {
  mixins: [flowMixin],
  name: 'DdXlsTemplateSearchDialog',
  components: {
    DdCodeTextBoxChild,
    DdCustomButton,
    DdEditDialog,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    DdTransparentButton
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: {
      type: Boolean,
      default: false
    },
    /**
     * ダイアログタイトル
     */
    titleText: {
      type: String,
      default: 'テンプレート検索'
    },
    /**
     * mstXlsImportMappingの対象formatCd
     */
    headerType: {
      type: String,
      default: ''
    },
    /**
     * 営業所ロックフラグ
     */
    eigyoshoReadOnly: {
      type: Boolean,
      default: false
    },
    /*
     * 省略表示モード
     */
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    },
    /*
     * 1ページ当たりの行数
     */
    itemsPerPage: {
      type: Number,
      default: 25
    },
    /*
     * 省略表示モード（コードテキストボックスで更に表示されるダイアログに対して）
     */
    abbreviatedDisplayChild: {
      type: Boolean,
      default: false
    },
    /*
     * 1ページ当たりの行数（コードテキストボックスで更に表示されるダイアログに対して）
     */
    itemsPerPageChild: {
      type: Number,
      default: 25
    }
  },
  data: () => ({
    isConditionHide: false,
    title: '',
    conditions: {
      xlsTemplateNm: null,
      sharyoCd: null,
      jininCd: null,
      eigyoshoCd: null,
      torihikisakiCd: null,
      hinmeiCd: null,
      hatsuchiCd: null,
      chakuchiCd: null
    },
    ddMasterSearchConditions: {
      xlsTemplateNm: null,
      sharyoCd: null,
      jininCd: null,
      eigyoshoCd: null,
      torihikisakiCd: null,
      hinmeiCd: null,
      hatsuchiCd: null,
      chakuchiCd: null
    },
    searchText: '',
    headers: [],
    rows: [],
    deleteTargetList: [],
    headersSharyoList: header.mstSharyoHeaders,
    headersJininList: header.mstJininHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,
    // 一覧選択用
    actionDefine: { text: '', value: 'actions', align: 'center' },
    deleteDefine: { text: '', value: 'delete', align: 'center' },
    // 一覧制御用
    selected: [],
    page: 1,

    innerItemsPerPage: null,
    innerItemsPerPageChild: null,
    editDialogKey: 0
  }),
  created () {
  },
  mounted () {
    this.title = this.titleText
  },
  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        scrollable: true,
        maxWidth: '80%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    // 使用元の画面でloadMastersを済ませてください
    ...mapGetters({
      xlsTemplateKihonList: 'DDMasters/mstXlsTemplateKihon',
      eigyoshoList: 'DDMasters/mstEigyosho',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      userEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredXlsTemplateKihonList () {
      const target = filter.dateFormatter(new Date())
      return this.xlsTemplateKihonList.filter(elem => {
        return elem.formatCd === this.headerType && elem.hyojiFlg
      }).map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder >= 0 ? filter.numericFormatter(elem.hyojiOrder) : ''

        const eigyosho = this.filteredEigyoshoList.find(item => item.eigyoshoCd === elem.eigyoshoCd) || {}
        const jinin = this.filteredJininList.find(item => item.jininCd === elem.jininCd) || {}
        const sharyo = this.filteredSharyoList.find(item => item.sharyoCd === elem.sharyoCd) || {}
        const torihikisaki = this.filteredTorihikisakiList.find(item => item.torihikisakiCd === elem.torihikisakiCd) || {}
        const hinmei = this.filteredHinmeiList.find(item => item.hinmeiCd === elem.hinmeiCd) || {}
        const hatsuchi = this.filteredHacchakuchiList.find(item => item.hacchakuchiCd === elem.hatsuchiCd) || {}
        const chakuchi = this.filteredHacchakuchiList.find(item => item.hacchakuchiCd === elem.chakuchiCd) || {}
        elem.eigyoshoNm = eigyosho.eigyoshoNm
        elem.jininNm = (jinin.jininNmSei || '') + (jinin.jininNmMei ? ' ' + jinin.jininNmMei : '')
        elem.sharyoNo = sharyo.sharyoNo
        elem.jidoshaHyojiNm = sharyo.jidoshaHyojiNm
        elem.torihikisakiNm = torihikisaki.torihikisakiNm
        elem.hinmeiNm = hinmei.hinmeiNm
        elem.hatsuchiNm = hatsuchi.hacchakuchiNm
        elem.chakuchiNm = chakuchi.hacchakuchiNm
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        return -1
      })
    },
    filteredSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (this.eigyoshoLockFlg || elem.eigyoshoCd === this.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.sharyoCd > elem2.sharyoCd) { return 1 }
        if (elem1.sharyoCd === elem2.sharyoCd) { return 0 }
        return -1
      })
    },
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (this.eigyoshoLockFlg || elem.eigyoshoCd === this.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(elem => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hacchakuchiCd > elem2.hacchakuchiCd) { return 1 }
        if (elem1.hacchakuchiCd === elem2.hacchakuchiCd) { return 0 }
        return -1
      })
    },
    filteredHatsuchiList () {
      return this.filteredHacchakuchiList.filter(elem => elem.hatsuchiFlg)
    },
    filteredChakuchiList () {
      return this.filteredHacchakuchiList.filter(elem => elem.chakuchiFlg)
    },
    filteredRows () {
      return this.rows.filter(elem => {
        return this.isDdMasterSearch(elem)
      })
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        deleteTargetList: this.deleteTargetList
      }
    },
    getRegisterTargetList: function () {
      const clone = this.cloneData.rows
      return this.rows.filter(elem => {
        const cln = clone.find(_elem => _elem.id === elem.id)
        return JSON.stringify(elem) !== JSON.stringify(cln)
      })
    },
    onSaveButtonClick: function () {
      const params = {
        registerTargetList: this.getRegisterTargetList(),
        deleteTargetList: this.deleteTargetList
      }
      console.log('register data', params)
      if (params.registerTargetList.length <= 0 && params.deleteTargetList.length <= 0) {
        // 登録データが存在しない場合、エラーメッセージを表示
        this.setInvalidSummaryMessage('COME0018')
        return
      }
      this.Effects.loadStart()
      return new Promise(resolve => {
        this.HttpClient.post('/api/v1/MstXlsTemplateKihon/UpdateMulti', params)
          .then((data) => {
            this._setMessages(data).then(() => {
              if (!data.isValid) {
                this.Effects.loadComplete()
                return
              }

              // indexedDBを最新化
              this.$store.dispatch('DDMasters/truncateMasters', { list: ['mstxlstemplatekihon'] }).then(() => {
                this.$store.dispatch('DDMasters/loadMasters', { list: ['mstxlstemplatekihon'], version: 1, kinoId: 0 }).then(() => {
                  this.$emit('close')
                  this.Effects.loadComplete()
                  resolve()
                })
              })
            })
          })
      })
    },
    onRowDeleteButtonClick: function (item) {
      this.rows = this.rows.filter(elem => elem.id !== item.id)
      this.deleteTargetList.push(item)
    },
    // 縦持ちのdetailを横持ちに変換
    detailToRow: function (detailList) {
      var rowNoInfo = {}
      // rowNo毎にデータをまとめる 処理としては空きのrowNoがあったとしても空き行を再現する
      const max = Math.max(...detailList.map(x => Number(x.rowNo)))
      for (let i = 1; i <= max; i++) {
        if (!rowNoInfo[i]) { rowNoInfo[i] = [] }
        var target = detailList.filter(item => Number(item.rowNo) === i)
        if (target.length > 0) { rowNoInfo[i] = target }
      }
      console.log('detailToRow rowNoInfo', rowNoInfo)
      // bindItemNmをプロパティとする行データを作成する
      const keys = Object.keys(rowNoInfo).sort((a, b) => a - b)
      var rowList = keys.reduce((res, cur) => {
        var row = (rowNoInfo[cur] || []).reduce((_res, _cur) => {
          _res[_cur.bindItemNm] = _cur.value
          return _res
        }, {})
        res.push(row)
        return res
      }, [])
      console.log('detailToRow rowList', rowList)

      return rowList
    },
    emitSelect: function (item) {
      const id = item.id
      this.Effects.loadStart()
      return new Promise(resolve => {
        this.HttpClient.get(`/api/v1/MstXlsTemplateDetail/GetByKihonId?id=${id}`)
          .then((data) => {
            const detailList = data.payload || []
            const rowList = this.detailToRow(detailList)
            this.$emit('select', rowList)
            this.Effects.loadComplete()
            resolve()
          })
      })
    },
    checkChangesPromise: function () {
      return new Promise(resolve => {
        const target = this.getCloneTargetMethod()
        const modified = this._compareClone(target)
        const p = modified ? modals.showConfirmYesNo : () => { return new Promise(resolve => resolve(true)) }
        p('COMQ0007').then((ok) => {
          if (modified && (ok === false || ok === undefined)) {
            return resolve(false)
          }
          return resolve(true)
        })
      })
    },
    onRowDoubleClick: function (e, f) {
      this.checkChangesPromise().then((ok) => {
        if (ok === true) {
          this.emitSelect(f.item)
        }
      })
    },
    onRowSelectButtonClick: function (item) {
      this.checkChangesPromise().then((ok) => {
        if (ok === true) {
          this.emitSelect(item)
        }
      })
    },
    onCloseClick: function (e) {
      this.checkChangesPromise().then((ok) => {
        if (ok === true) {
          this.$emit('close')
        }
      })
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
      })
      this.Effects.loadComplete()
    },
    onSearchButtonClick: function (e) {
      this.checkChangesPromise().then((ok) => {
        if (ok === true) {
          this.rows = dolly.clone(this.filteredXlsTemplateKihonList)
          this.deleteTargetList = []

          this.ddMasterSearchConditions = Object.assign({}, this.conditions)
        }
      })
    },
    isDdMasterSearch (elem) {
      const cond = this.ddMasterSearchConditions
      const isMatchedXlsTemplateNm = this.isMatchPartial(cond.xlsTemplateNm, elem.xlsTemplateNm)
      const isMatchedSharyoCd = this.isMatchExact(cond.sharyoCd, elem.sharyoCd)
      const isMatchedJininCd = this.isMatchExact(cond.jininCd, elem.jininCd)
      const isMatchedEigyoshoCd = this.isMatchExact(cond.eigyoshoCd, elem.eigyoshoCd)
      const isMatchedTorihikisakiCd = this.isMatchExact(cond.torihikisakiCd, elem.torihikisakiCd)
      const isMatchedHinmeiCd = this.isMatchExact(cond.hinmeiCd, elem.hinmeiCd)
      const isMatchedHatsuchiCd = this.isMatchExact(cond.hatsuchiCd, elem.hatsuchiCd)
      const isMatchedChakuchiCd = this.isMatchExact(cond.chakuchiCd, elem.chakuchiCd)
      return isMatchedXlsTemplateNm && isMatchedSharyoCd && isMatchedJininCd && isMatchedEigyoshoCd && isMatchedTorihikisakiCd && isMatchedHinmeiCd && isMatchedHatsuchiCd && isMatchedChakuchiCd
    },
    // 部分一致
    isMatchPartial: function (condition, target) {
      if (this.isNullOrEmpty(condition)) { return true }
      if (this.isNullOrEmpty(target)) { return false }
      return target.indexOf(condition) !== -1
    },
    // 完全一致
    isMatchExact: function (condition, target) {
      if (this.isNullOrEmpty(condition)) { return true }
      if (this.isNullOrEmpty(target)) { return false }
      return target === condition
    },
    isNullOrEmpty: function (value) {
      return value === undefined || value === null || value === ''
    },
    // ----------------------------------------------------------------------------------------------------
    // DdEditDialog
    // ----------------------------------------------------------------------------------------------------
    onSaveXlsTemplateNm: function (e, item) {
      // 最大文字数でカット
      item.xlsTemplateNm = e?.slice(0, 50)
    },
    onCloseXlsTemplateNm: function (item) {
      // 強制的に再描画 ※editDialogが上記処理のような外部からの変更に優しくない
      this.editDialogKey++
    },
    onSaveXlsHyojiOrder: function (e, item) {
      item.hyojiOrderDisp = e
      item.hyojiOrder = e
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.rows = dolly.clone(this.filteredXlsTemplateKihonList)
      this.deleteTargetList = []
      this.headers = this.getHeader()
      const initConditions = {
        xlsTemplateNm: null,
        sharyoCd: null,
        jininCd: null,
        eigyoshoCd: this.userEigyoshoCd,
        torihikisakiCd: null,
        hinmeiCd: null,
        hatsuchiCd: null,
        chakuchiCd: null
      }
      this.conditions = Object.assign({}, initConditions)
      this.ddMasterSearchConditions = Object.assign({}, initConditions)
      this.searchText = ''
      this.innerItemsPerPage = this.itemsPerPage
      this.innerItemsPerPageChild = this.itemsPerPageChild

      this.cloneData = dolly.clone(this.getCloneTargetMethod())
    },
    getHeader: function () {
      var header = []
      header.push(this.actionDefine)
      header.push({ text: 'テンプレート名', value: 'xlsTemplateNm', width: '100%' })
      header.push({ text: '営業所コード', value: 'eigyoshoCd' })
      header.push({ text: '営業所名称', value: 'eigyoshoNm' })
      header.push({ text: '人員コード', value: 'jininCd' })
      header.push({ text: '人員氏名', value: 'jininNm' })
      header.push({ text: '車両番号', value: 'sharyoNo' })
      header.push({ text: '自動車表示名', value: 'jidoshaHyojiNm' })
      header.push({ text: '取引先コード', value: 'torihikisakiCd' })
      header.push({ text: '取引先名称', value: 'torihikisakiNm' })
      header.push({ text: '品名コード', value: 'hinmeiCd' })
      header.push({ text: '品名', value: 'hinmeiNm' })
      header.push({ text: '発地コード', value: 'hatsuchiCd' })
      header.push({ text: '発地名称', value: 'hatsuchiNm' })
      header.push({ text: '着地コード', value: 'chakuchiCd' })
      header.push({ text: '着地名称', value: 'chakuchiNm' })
      header.push({ text: '適用開始日', value: 'tekiyoStartYmdDisp' })
      header.push({ text: '適用終了日', value: 'tekiyoEndYmdDisp' })
      header.push({ text: '表示順', value: 'hyojiOrderDisp' })
      header.push(this.deleteDefine)
      return header
    },
    changeItemsPerPage: function (e) {
      this.innerItemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.innerItemsPerPage, this.page)
        // this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.innerItemsPerPage, this.page)
        // this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 600 !important;
}
</style>
